// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"39337222","94":"b40fa8c6","111":"3f61ed1e","334":"353d271e","577":"71f18f86","604":"779fbc6e","649":"e7c54b4b","711":"6708ece2","764":"426c9f89","920":"adc726a5","948":"daa5be6d","953":"c8a51c4c"}[chunkId] + ".chunk.js";
};